import React from "react";

const WebContentList = () => {
  return <div>web content list</div>;
};

export default WebContentList;
